import styled, { css } from 'styled-components';
import { MAX_PRIMARY_PAGE_WIDTH } from 'domain/style';
import { Container } from 'styles';

// TODO - find a way to handle this via a more flexible
// layout component
export const Banner = styled(Container)<StyleProps>`
  background: ${props => props.theme.colors.background[props.color!]};
  left: 50%;
  margin-left: -50vw;
  padding-bottom: 48px;
  padding-left: calc((100vw - ${MAX_PRIMARY_PAGE_WIDTH}) / 2 + 32px);
  padding-right: calc((100vw - ${MAX_PRIMARY_PAGE_WIDTH}) / 2 + 32px);
  padding-top: 48px;
  position: relative;
  width: 100vw;
  opacity: ${props => props.theme.opacities[props.opacity]};
  overflow: hidden;

  ${props => props.theme.media.medium`
    padding: 32px;
  `}
`;

const pseudoLinkStyles = props =>
  props.onClick &&
  css`
    &:hover {
      cursor: pointer;
      text-decoration-line: underline;
      text-decoration-color: ${props =>
        props.theme.colors.content.primaryInverse};
    }
  `;

const clickableBannerAttrs = () => ({
  alignItems: 'center',
  flex: true,
  margin: {
    top: '24px',
  },
  padding: '16px',
});

export const ClickableBanner = styled(Container).attrs(clickableBannerAttrs)`
  border-radius: ${props => props.theme.borderRadii.large};
  background: ${props => props.theme.colors.background[props.backgroundColor]};
  ${pseudoLinkStyles}
`;
